import api from "./api";

export const getJobHierarchyFlat = async (companyId) => {
  if (companyId == null) throw new Error("companyId is required");
  const res = await api.get(`/job-hierarchy/company/${encodeURIComponent(companyId)}/flat`);
  return Array.isArray(res) ? res : [];
};

export const reparentJob = async (companyId, childJobId, newParentJobId) => {
  if (companyId == null) throw new Error("companyId is required");
  const cid = Number(childJobId);
  if (!cid || isNaN(cid)) throw new Error("Valid childJobId is required");
  return api.patch(`/job-hierarchy/company/${encodeURIComponent(companyId)}/reparent`, {
    childJobId: cid,
    newParentJobId: newParentJobId ? Number(newParentJobId) : null,
  });
};

export const bulkReparentJobs = async (companyId, changes) => {
  if (companyId == null) throw new Error("companyId is required");
  return api.patch(`/job-hierarchy/company/${encodeURIComponent(companyId)}/bulk-reparent`, {
    changes,
  });
};
